import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

//Components
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';
import { Modal, Button } from "@gpstrackit/gtc-react-controls";

//Actions
import { maintenanceMDSDeleteMaintenanceService, openModalDeleteMaintenanceService, reset } from './redux/slice';

//Styles
import './styles.scss';

const DeleteMaintenanceService = (props) => {
    const { refresh } = props
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const [errors, setErrors] = useState(null)
    const [validateScheduledServices, setValidateScheduledServices] = useState([])

    const {
        open,
        maintenanceService,
        loading,
        result,
        maintenanceServicesList,
        error,
    } = useSelector(state => state.maintenanceDeleteMaintenanceServiceRedux);

    const { loadingScheduledServices, scheduledServices } = useSelector(state => state.maintenanceScheduledServicesRedux)

    const handleDeleteSubmit = () => {
        if (maintenanceServicesList && maintenanceServicesList.length > 0) {
            dispatch(maintenanceMDSDeleteMaintenanceService({ items: maintenanceServicesList }))
        } else dispatch(maintenanceMDSDeleteMaintenanceService({ id: maintenanceService.id }))
    }

    const handleClose = () => {
        dispatch(openModalDeleteMaintenanceService({ open: false, maintenanceService: {}, maintenanceServicesList: [] }))
        setErrors(null);
    };

    useEffect(() => {
        if (open && !loading && result) {
            let messageSuccess = maintenanceService?.id ? messages['maintenanceDeleteMaintenanceService_deleteConfirmationSuccessfully'] : messages['maintenanceDeleteMaintenanceService_deleteSevicesConfirmationSuccessfully']
            NotificationManager.success(
                messageSuccess,
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            refresh()
            dispatch(reset())
        }
    }, [loading, result])

    useEffect(() => {
        if (open && scheduledServices && scheduledServices.length > 0) {
            let statusDone = scheduledServices.some((service) => service.status === 'Done');
            let statusScheduled = scheduledServices.some((service) => service.status === 'Scheduled' || service.status === 'Due Soon' || service.status === 'Due' || service.status === 'Past Due');
            if (statusScheduled) setErrors('Scheduled')
            if (statusDone) setErrors('Done')
        }
    }, [scheduledServices])

    useEffect(() => {
        if (maintenanceServicesList.length) {
            let validateServices = maintenanceServicesList.filter((item) => item.scheduledServices >= 0);
            setValidateScheduledServices(validateServices)
        }
    }, [maintenanceServicesList])

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }))
        }
    }, [error])

    let title = maintenanceServicesList.length === 1 && maintenanceServicesList.find((service) => service.title)

    let deleteService = maintenanceService?.title || title.title

    return (
        <Modal
            title={deleteService ? `${messages['maintenanceDeleteMaintenanceService_deleteLabel']} "${deleteService}" ` : messages['maintenanceDeleteMaintenanceService_deleteServicesLabel']}
            size="small"
            loading={loading || loadingScheduledServices}
            open={open}
            handleClose={handleClose}
            footer={(
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={(e) => {
                            handleDeleteSubmit();
                        }}
                        isDisabled={loading || loadingScheduledServices || errors === 'Done'}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '0px 25px' }}>
                {!errors && maintenanceServicesList.length === 0 && (
                    <p style={{ overflowWrap: 'anywhere' }}>
                        {`${messages['maintenanceDeleteMaintenanceService_messageDelete']} "${maintenanceService?.title}"`}?
                    </p>
                )}
                {errors === 'Done' && (
                    <p style={{ overflowWrap: 'anywhere' }}>
                        {`${messages['maintenanceDeleteMaintenanceService_deleteConfirmationDone']}`}
                    </p>
                )}
                {errors === 'Scheduled' && maintenanceService?.title && (
                    <p style={{ overflowWrap: 'anywhere' }}>
                        {`${messages['maintenanceDeleteMaintenanceService_theServiceLabel']} "${maintenanceService?.title}" ${messages['maintenanceDeleteMaintenanceService_isProgrammed']}`}?
                    </p>
                )}
                {maintenanceServicesList && maintenanceServicesList.length > 0 && (
                    <>
                        {validateScheduledServices.length > 0 ? (
                            <div>
                                {validateScheduledServices.length === 1 && maintenanceServicesList.length === 1 ? validateScheduledServices.map((service, index) => {
                                    return (
                                        <p style={{ overflowWrap: 'anywhere' }} key={index}>
                                            {`${messages['maintenanceDeleteMaintenanceService_theServiceLabel']} "${service?.title}" ${messages['maintenanceDeleteMaintenanceService_isProgrammed']}`}?
                                        </p>
                                    )
                                }) : (
                                    <div>
                                        <p style={{ overflowWrap: 'anywhere', fontWeight: 600 }}>
                                            {messages['maintenanceDeleteMaintenanceService_messageScheduledServices']}?
                                        </p>
                                        <p>{messages['maintenanceDeleteMaintenanceService_scheduledServicesLabel']} :</p>
                                        <ul>
                                            {validateScheduledServices.map((service, index) => {
                                                return <li key={index}>{service.title}</li>
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ) : <>
                            {
                                maintenanceServicesList.length > 1 ? (<p style={{ overflowWrap: 'anywhere' }}>{messages['maintenanceDeleteMaintenanceService_messageDeleteServices']}?</p>) : maintenanceServicesList && maintenanceServicesList.map((service, index) => {
                                    return (<p style={{ overflowWrap: 'anywhere' }} key={index}>
                                        {`${messages['maintenanceDeleteMaintenanceService_messageDelete']} "${service?.title}"`}?
                                    </p>)
                                })
                            }
                        </>}
                    </>
                )}
            </div>
            <NotificationContainer />
        </Modal>
    )
}

export default DeleteMaintenanceService
